export default __webpack_public_path__ + "static/media/calendar.53d3a651.svg";